module.exports = __webpack_public_path__ + "static/media/jira.a397460c.svg";